export default {"src":"/_next/static/media/squarecheck.c7d897d0.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};